import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, LogOut, Package } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import logo from '../assets/logo.png';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
    setIsOpen(false);
  };

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ type: 'spring', stiffness: 100, damping: 20 }}
      className="fixed top-0 left-0 right-0 z-50 bg-gray-950/80 backdrop-blur-xl border-b border-gray-800/50"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center space-x-2">
            <motion.div
              whileHover={{ rotate: 360 }}
              transition={{ duration: 0.5 }}
              className="w-8 h-8 rounded-lg overflow-hidden"
            >
              <img src={logo} alt="Logo" className="w-full h-full object-cover" />
            </motion.div>
            <span className="text-xl font-bold gradient-text">Advance Advert Tv Digital</span>
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-gray-300 hover:text-white transition-colors">Home</Link>
            <Link to="/create-request" className="text-gray-300 hover:text-white transition-colors">Get Account</Link>
            <Link to="/track" className="text-gray-300 hover:text-white transition-colors flex items-center gap-1">
              <Package size={16} /> Track Order
            </Link>
            {user && (
              <button onClick={handleLogout} className="text-gray-400 hover:text-red-400 transition-colors flex items-center gap-1">
                <LogOut size={16} /> Logout
              </button>
            )}
          </div>

          <button onClick={() => setIsOpen(!isOpen)} className="md:hidden text-gray-400 hover:text-white">
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-gray-900 border-b border-gray-800"
          >
            <div className="px-4 py-4 space-y-3">
              <Link to="/" onClick={() => setIsOpen(false)} className="block text-gray-300 hover:text-white py-2">Home</Link>
              <Link to="/create-request" onClick={() => setIsOpen(false)} className="block text-gray-300 hover:text-white py-2">Get Account</Link>
              <Link to="/track" onClick={() => setIsOpen(false)} className="block text-gray-300 hover:text-white py-2">Track Order</Link>
              {user && (
                <button onClick={handleLogout} className="block text-red-400 hover:text-red-300 py-2">Logout</button>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.nav>
  );
};

export default Navbar;
